import { Divider } from '@mui/material'
import { Icon, Typography } from 'components'
import { TypographyTypes } from 'interfaces'
import React from 'react'

interface CardAlertProps {
	icon: string
	title: string
	description: string
}

export const CardAlert: React.FC<CardAlertProps> = ({
	icon,
	title,
	description
}) => {
	return (
		<div className="flex items-center justify-between rounded-lg p-2 w-full bg-[#EBF9FA]">
			<div className="flex items-center gap-6 w-full">
				<div className="flex-none">
					<Icon
						src={icon}
						fillPath
						className="text-blue-primary w-[48px] h-[48px] ml-4"
					/>
				</div>
				<Divider orientation="vertical" flexItem />
				<div className="flex flex-col ml-18 flex-grow overflow-hidden">
					<Typography
						title={title}
						fontLeading="14/24"
						type={TypographyTypes.p}
						className="text-black-1 font-normal text-base font-bold"
					/>
					<div className="flex items-center gap-2">
						<Typography
							title={description}
							fontLeading="14/24"
							type={TypographyTypes.p}
							className="text-gray-13 font-normal text-base break-words"
						/>
					</div>
				</div>
			</div>
		</div>
	)
}
